import React from "react";
import "./../styles.css";
import "../assets/css/all.css"

import Title from "./TitleComponent"
import Label from "./LabelComponent"
import Div from './DivComponent'
import AttachDocument from "./AttachFileComponent"
import ButtonClick from "./ButtonClickComponent"
import ButtonSubmit from "./ButtonSubmitComponent"
import Calendar from "./CalendarComponent"
import Checkbox from "./CheckboxComponent"
import InputText from "./InputTextComponent"
import RadioButton from "./RadioButtonComponent"
import Select from "./SelectComponent"
import TextArea from "./TextAreaComponent"
import PrintDocument from "./PrintDocumentComponent"
import Question from "./QuestionComponent"

export const types = {
  title: "title",     //
  label: "label",         //
  div: "div",         //
  divContainer: "divContainer",   //
  attach: "attach",       //
  calendar: "calendar",     //
  cancel: "cancel",         //
  checkbox: "checkbox",     //
  number: "number",       //
  password: "password",   //
  email: "email",   //
  print: "print",
  question: "question",     //
  radiobutton: "radiobutton",   //
  select: "select",     //
  submit: "submit",     //
  text: "text",       //
  textarea: "textarea",
  buttonclick: "buttonclick",    //
  click: "click"    //
};

const FormComponent = ({ objectCreator, handlerChange, handlerSubmit }) => {
  return (
    <>
      {objectCreator.map((item, pos) =>
        createForm(item, pos, handlerChange, handlerSubmit)
      )}
    </>
  );
}

export default FormComponent

const createForm = (item, pos, handlerChange, handlerSubmit) => {
  switch (item.type) {
    case types.title:
      return (
        <Title
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      );
    case types.label:
      return (
        <Label
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.div:
    case types.divContainer:
      return (
        <Div config={item} key={`form-item-${pos}`} />
      )
    case types.text:
    case types.number:
    case types.password:
    case types.email:
      return (
        <InputText
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.calendar:
      return (
        <Calendar
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.click:
    case types.buttonclick:
      return (
        <ButtonClick
          config={{ ...item }}
          key={`form-item-${pos}`}
        />
      )
    case types.attach:
      return (
        <AttachDocument
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.checkbox:
      return (
        <Checkbox
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.print:
      return (
        <PrintDocument
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.question:
      return (
        <Question
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.radiobutton:
      return (
        <RadioButton
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.select:
      return (
        <Select
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      )
    case types.submit:
      return (
        <ButtonSubmit
          config={item}
          onSubmit={handlerSubmit}
          key={`form-item-${pos}`}
        />
      )
    case types.textarea:
      return (
        <TextArea
          config={item}
          onChange={handlerChange}
          key={`form-item-${pos}`}
        />
      );
    default:
      return <></>
  }
}
